import React from 'react';
import { Card, Container } from 'react-bootstrap';
import './Project.css';
import Slider from "react-slick";
import usePort from '../Dataload/port';
import { NavLink } from 'react-router-dom';

const Project = () => {
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ]
    };
    const [project] = usePort()
    const reactPro = project.filter(pro => pro.type === "react")
    const jsPro = project.filter(pro => pro.type === "JS")
    const htPro = project.filter(pro => pro.type === "html")
    return (
        <Container fluid className='custo'>
            <div className="Title mb-5">
                <h3>Projects
                    <span> Portfolio</span>
                </h3>
            </div>
            <div className='cont'>
                <h2 className='text-bg '>React & Full-Stack Projects</h2>
                <hr className='ms-3 mb-3 bg-white' />
            </div>
            <Container className=' cont '>
                <Slider {...settings} >
                    {reactPro.map(data => (
                        <div className="px-2   ">
                            <Card key={data.key} className=' h-75 c cb ' >
                                <div className="image-data">


                                    <Card.Img variant="" src={data.img} className='img-fluid pb-5   ' />

                                    <Card.Body className=' h-50 pt-5 reviw'>
                                        <Card.Title className='text-center fw-bold '>{data.name}</Card.Title>
                                        <Card.Text className='fs-6 text-center'>
                                            {data.descript.slice(0, 95)}
                                        </Card.Text>
                                    </Card.Body>
                                    <ul className="hover-items">
                                        <li>
                                            <a target="_blank" rel="noopener noreferrer" href={data.live}>Live</a>
                                            {data.details && <NavLink to={`/details/${data.key}`}>Details</NavLink>}
                                            {!data.details && <a target="_blank" rel="noopener noreferrer" href={data.git}>Git</a>}
                                        </li>
                                    </ul></div>
                            </Card>
                        </div>
                    ))}
                </Slider>
            </Container>
            {/* javascript */}
            <div className='cont mt-5'>
                <h2 className=' '>JavaScript Projects</h2>
                <hr className='ms-3 mb-3 w-50 bg-white' />
            </div>
            <Container className=' cont '>
                <Slider {...settings} >
                    {jsPro.map(data => (
                        <div className="px-2">
                            <Card key={data.key} className=' h-75 c cb ' >
                                <div className="image-data">

                                    <Card.Img variant="" src={data.img} className='img-fluid    ' />

                                    <Card.Body className=' h-50'>
                                        <Card.Title className='text-center fw-bold '>{data.name}</Card.Title>
                                        <Card.Text className='fs-6 text-center'>
                                            {data.descript.slice(0, 95)}
                                        </Card.Text>
                                    </Card.Body>
                                    <ul className="hover-items">
                                        <li>
                                            <a target="_blank" rel="noopener noreferrer" href={data.live}>Live</a>
                                            <a target="_blank" rel="noopener noreferrer" href={data.git}>Git</a>
                                        </li>
                                    </ul></div>
                            </Card>
                        </div>
                    ))}
                </Slider>
            </Container>
            <div className='cont mt-5'>
                <h2 className=' '>HTML & BOOTSTRAP</h2>
                <hr className='ms-3 mb-3 w-50 bg-white' />
            </div>
            <Container className=' cont '>
                <Slider {...settings} >
                    {htPro.map(data => (
                        <div className="px-2  ">
                            <Card key={data.key} className=' h-75 c cb ' >
                                <div className="image-data">

                                    <Card.Img variant="" src={data.img} className='img-fluid    ' />

                                    <Card.Body className=' h-50'>
                                        <Card.Title className='text-center fw-bold '>{data.name}</Card.Title>
                                        <Card.Text className='fs-6 text-center'>
                                            {data.descript.slice(0, 95)}
                                        </Card.Text>
                                    </Card.Body>
                                    <ul className="hover-items">
                                        <li>
                                            <a target="_blank" rel="noopener noreferrer" href={data.live}>Live</a>
                                            <a target="_blank" rel="noopener noreferrer" href={data.git}>Git</a>
                                        </li>
                                    </ul>
                                </div>
                            </Card>
                        </div>
                    ))}
                </Slider>
            </Container>
        </Container >
    );
};

export default Project;